module.exports = __webpack_public_path__ + "static/media/speaker-zhixing-mobile.2b63e8f7.jpg";